import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, UrlTree} from '@angular/router';

import {REDIRECT} from '../models/auth';
import {AuthenticationRoutesMatcher} from '../routing/auth.routes';
import {CommonRoutingMatcher} from '../routing/common.routes';
import {Q9maCookieService} from '../services/cookie.service';
import {RedirectService} from '../services/redirect.service';

export function RedirectGuard(route: ActivatedRouteSnapshot): boolean | UrlTree {
  const matcher = route.routeConfig?.matcher;
  const isAuthenticationRoute = matcher === AuthenticationRoutesMatcher;
  const cookieService = inject(Q9maCookieService);
  const redirectService = inject(RedirectService);
  const rawRedirect = route.queryParamMap.get(REDIRECT);
  const decodedQueryRedirect = rawRedirect ? redirectService.safeDecode(rawRedirect) : null;

  // If route is authentication route and redirect query param is present,
  // update redirect param in cookies and let it pass through
  if (
    isAuthenticationRoute &&
    decodedQueryRedirect &&
    redirectService.allowed(decodedQueryRedirect)
  ) {
    cookieService.updateRedirect(rawRedirect!);

    return true;
  }

  const isSpaceRoute = matcher === CommonRoutingMatcher;
  const redirect = cookieService.getRedirect();

  if (!redirect || !redirectService.allowed(redirect)) {
    cookieService.deleteRedirect();

    return true;
  }

  // If route is space route and redirect param is present in cookies,
  // delete redirect param and redirect to the saved url
  if (isSpaceRoute && redirect) {
    cookieService.deleteRedirect();

    window.location.href = redirect;

    return false;
  }

  return true;
}
